import { formatDate } from "@/helper";

export default {
  data() {
    return {
      control: {
        patient_type: "new",
        age_type: "adult",
        scheduling_for: "myself",
        relationship: { value: "spouse", label: "Spouse/Partner" },
        first_name: "",
        last_name: "",
        middle_initial: "",
        email: "",
        gender: "M",
        birth_date: "",
        mobile_phone: "",
        home_phone: "",
        work_phone: "",
        appointment_notes: "",
        has_insurance: false,
        insurance: null,
        other_insurance: "",
        plan_name: "",
        group_number: "",
        insurance_phone_number: "",
        member_id_number: "",
        employer_name: "",
        home_zipcode: "",
        is_policy_holder: true,
        policy_holders_firstname: "",
        policy_holders_lastname: "",
        policy_holders_dob: "",

        has_secondary_insurance: false,
        secondary_insurance: null,
        secondary_other_insurance: "",
        secondary_plan_name: "",
        secondary_group_number: "",
        secondary_insurance_phone_number: "",
        secondary_member_id_number: "",
        secondary_employer_name: "",
        secondary_home_zipcode: "",
        secondary_is_policy_holder: true,
        secondary_policy_holders_firstname: "",
        secondary_policy_holders_lastname: "",
        secondary_policy_holders_dob: "",

        provider: null,
        locations: null,
        services: null,
        availability: null,
        address: "",
        state: null,
        zip: "",
        city: "",
        type: null,
        confirm: false,
        upload_image_patient: null,
        upload_image_insurance: null,
        upload_image_secondary_insurance: null,
        guardian_first_name: "",
        guardian_last_name: "",
        guardian_email: "",
        guardian_mobile_phone: "",

        appointment_source: "Patient Booked",
      },
    };
  },
  computed: {
    input() {
      const control = this.control;
      const config = this.$store.state.config;
      const meta = this.$store.state.meta;
      let input = {};

      input.first_name = control.first_name;
      input.last_name = control.last_name;
      input.middle_initial = control.middle_initial;
      input.email = control.email;
      input.gender = control.gender;
      input.home_phone = control.home_phone;
      input.mobile_phone = control.mobile_phone;
      input.work_phone = control.work_phone;
      input.appointment_notes = control.appointment_notes;
      input.appointment_source = control.appointment_source;
      input.for_someone_else = "no";

      // Assign user information
      if (control.scheduling_for === "someone-else") {
        input.guardian_first_name = control.guardian_first_name;
        input.guardian_last_name = control.guardian_last_name;
        input.guardian_email = control.guardian_email;
        input.guardian_mobile_phone = control.guardian_mobile_phone;
        input.for_someone_else = "yes";
      }

      // Assign `meta` options
      input.meta = {};
      input.meta.rwg_token = config?.rwg_token || "";
      input.meta.is_rwg = config?.rwg_token && config?.reservedWithGoogle;
      input.meta.did_ocr_id_scan = meta.didOcrIdScan;
      input.meta.did_ocr_insurance_scan = meta.didOcrInsuranceScan;
      input.meta.did_ocr_secondary_insurance_scan = meta.didOcrSecondaryInsuranceScan;
      input.meta.ttb_secs = meta.totalBookingTimeInSeconds;

      // Set `id_scan_result` and `insurance_scan_result` in `meta` options
      if (input.meta.did_ocr_id_scan) {
        input.meta.id_scan_result = meta.idScanResult;
      }

      if (input.meta.did_ocr_insurance_scan) {
        input.meta.insurance_scan_result = meta.insuranceScanResult;
      }

      if (input.meta.did_ocr_secondary_insurance_scan) {
        input.meta.secondary_insurance_scan_result = meta.secondaryInsuranceScanResult;
      }

      if (config?.reservedWithGoogle) {
        const referrer = document.referrer;
        const query = referrer?.includes("?") ? "&" : "?";
        const slash = referrer?.slice(-1) === "/" ? "" : "/";
        const url = `${referrer}${slash}${query}utm_source=Reserved With Google`;
        input.referer = encodeURIComponent(url);
      } else {
        input.referer = encodeURIComponent(document.referrer);
      }

      // Get `referrer` in `referrer` options
      if (config?.referrer) {
        input.referer = encodeURIComponent(config.referrer);
      }

      // Get `referrer` in `config.override` options
      if (config?.override?.referrer) {
        input.referer = encodeURIComponent(config.override.referrer);
      }

      if (control?.type) {
        input.type = control.type;
      }

      if (control?.birth_date && control?.birth_date.length === 10) {
        input.birth_date = formatDate(control.birth_date);
      }

      if (control?.services) {
        input.service_id = control.services.id;
        input.appointment_length = control.services.duration;
      }

      if (control?.availability) {
        const date = control.availability.date;
        const time = control.availability.time.start;
        const dateTime = `${date} ${time}`;
        input.operatory_id = control.availability.time.operatory_id;
        input.appointment_datetime = dateTime ? dateTime : undefined;
        input.location_id = control.availability.location_id;
        input.hash = control.availability.time.hash;

        if (control.availability?.provider_id) {
          input.provider_id = control.availability.provider_id;
        }
      }

      let insurance = {};
      if (control.has_insurance) {
        insurance.employer_name = control.employer_name;
        insurance.home_zipcode = control.home_zipcode;

        if (control?.insurance) {
          if (control.insurance.id !== "other") {
            insurance.insurance_id = control.insurance.id;
            insurance.insurance_carrier_name = control.insurance.name;
          } else if (control?.other_insurance) {
            insurance.other_insurance = control.other_insurance;
            insurance.insurance_id = "other";
            insurance.insurance_carrier_name = "Other";
          }
        }

        if (control.plan_name !== "") {
          insurance.plan_name = control.plan_name;
        }

        if (control.group_number !== "") {
          insurance.group_number = control.group_number;
        }

        if (control.insurance_phone_number !== "") {
          insurance.insurance_phone_number =
            control.insurance_phone_number;
        }

        if (control.member_id_number !== "") {
          insurance.member_id_number = control.member_id_number;
        }

        if (!control.is_policy_holder) {
          insurance.policy_holders_firstname =
            control.policy_holders_firstname;
          insurance.policy_holders_lastname =
            control.policy_holders_lastname;
          insurance.policy_holders_dob = control.policy_holders_dob;
        } else {
          insurance.policy_holders_firstname =
            control.policy_holders_firstname;
          insurance.policy_holders_lastname =
            control.policy_holders_lastname;
          insurance.policy_holders_dob = control.policy_holders_dob;
          // if (settings?.insurance_fields?.first_name_required) {
          //   input.insurance.policy_holders_firstname =
          //     control.policy_holders_firstname;
          // }
          // if (settings?.insurance_fields?.last_name_required) {
          //   input.insurance.policy_holders_lastname =
          //     control.policy_holders_lastname;
          // }
          // if (settings?.insurance_fields?.birth_date_required) {
          //   input.insurance.policy_holders_dob = control.policy_holders_dob;
          // }
        }

        if (
          insurance.policy_holders_dob &&
          insurance.policy_holders_dob.length === 10
        ) {
          insurance.policy_holders_dob = formatDate(
            insurance.policy_holders_dob
          );
        }
      }

      let secondary_insurance = {};
      if (control.has_secondary_insurance) {
        secondary_insurance.employer_name = control.secondary_employer_name;
        secondary_insurance.home_zipcode = control.secondary_home_zipcode;

        if (control?.secondary_insurance) {
          if (control.secondary_insurance.id !== "other") {
            secondary_insurance.insurance_id = control.secondary_insurance.id;
            secondary_insurance.insurance_carrier_name = control.secondary_insurance.name;
          } else if (control?.secondary_other_insurance) {
            secondary_insurance.other_insurance = control.secondary_other_insurance;
            secondary_insurance.insurance_id = "other";
            secondary_insurance.insurance_carrier_name = "Other";
          }
        }

        if (control.secondary_plan_name !== "") {
          secondary_insurance.plan_name = control.secondary_plan_name;
        }

        if (control.secondary_group_number !== "") {
          secondary_insurance.group_number = control.secondary_group_number;
        }

        if (control.secondary_insurance_phone_number !== "") {
          secondary_insurance.insurance_phone_number =
            control.secondary_insurance_phone_number;
        }

        if (control.secondary_member_id_number !== "") {
          secondary_insurance.member_id_number = control.secondary_member_id_number;
        }

        if (!control.secondary_is_policy_holder) {
          secondary_insurance.policy_holders_firstname =
            control.secondary_policy_holders_firstname;
          secondary_insurance.policy_holders_lastname =
            control.secondary_policy_holders_lastname;
          secondary_insurance.policy_holders_dob = control.secondary_policy_holders_dob;
        } else {
          secondary_insurance.policy_holders_firstname =
            control.secondary_policy_holders_firstname;
          secondary_insurance.policy_holders_lastname =
            control.secondary_policy_holders_lastname;
          secondary_insurance.policy_holders_dob = control.secondary_policy_holders_dob;
        }

        if (
          secondary_insurance.policy_holders_dob &&
          secondary_insurance.policy_holders_dob.length === 10
        ) {
          secondary_insurance.policy_holders_dob = formatDate(
            secondary_insurance.policy_holders_dob
          );
        }
      }

      input.insurance = [insurance, secondary_insurance].filter(obj => Object.keys(obj).length > 0);

      if (control?.locations?.software === "dentrixascend") {
        if (control?.address) input.address = control.address;
        if (control?.state) input.state = control.state.value;
        if (control?.zip) input.zip = control.zip;
        if (control?.city) input.city = control.city;
      }

      return input;
    },
  },
  methods: {
    resetForm() {
      this.control.patient_type = "new";
      this.control.age_type = "adult";
      this.control.first_name = "";
      this.control.last_name = "";
      this.control.middle_initial = "";
      this.control.email = "";
      this.control.gender = "M";
      this.control.birth_date = "";
      this.control.mobile_phone = "";
      this.control.home_phone = "";
      this.control.work_phone = "";
      this.control.appointment_notes = "";
      this.control.has_insurance = true;
      this.control.provider = null;

      this.control.is_policy_holder = false;
      this.control.insurance = null;
      this.control.other_insurance = "";
      this.control.group_number = "";
      this.control.insurance_phone_number = "";
      this.control.member_id_number = "";
      this.control.employer_name = "";
      this.control.home_zipcode = "";
      this.control.policy_holders_firstname = "";
      this.control.policy_holders_lastname = "";
      this.control.policy_holders_dob = "";

      this.control.secondary_is_policy_holder = false;
      this.control.secondary_insurance = null;
      this.control.secondary_other_insurance = "";
      this.control.secondary_group_number = "";
      this.control.secondary_insurance_phone_number = "";
      this.control.secondary_member_id_number = "";
      this.control.secondary_employer_name = "";
      this.control.secondary_home_zipcode = "";
      this.control.secondary_policy_holders_firstname = "";
      this.control.secondary_policy_holders_lastname = "";
      this.control.secondary_policy_holders_dob = "";

      this.control.locations = null;
      this.control.services = null;
      this.control.availability = null;
      this.control.address = "";
      this.control.state = null;
      this.control.zip = "";
      this.control.city = "";
      this.control.confirm = false;
      this.control.upload_image_patient = null;
      this.control.upload_image_insurance = null;
      this.control.upload_image_secondary_insurance = null;

      this.control.appointment_source = "Patient Booked";
    },
  },
};
